import {BottomSheet} from 'react-spring-bottom-sheet';
import cn from 'classnames';
import Accordion from '../../../../../../components/mazraeKit/accordion';
import {useEffect, useState} from 'react';
import {myStoreFiltersData, myStoreMultiSelectData} from '../../../contants';
import {RootState} from '../../../../../../store/redux';
import {useDispatch, useSelector} from 'react-redux';
import CustomMultiCheckbox from '../../../../../../components/mazraeKit/customMultiCheckbox';
import {addFilters, clearFilter} from '../../../../../../store/redux/myStore';
import InputLists from '../../../../../../module/newShop/home/inputLists';

interface IFiltersKeyValuePairs {
  guid: string;
  title: string;
}

interface IFiltersData {
  id: string;
  value: string;
  title: string;
}
export interface IMyStoreFilters {
  categories: Array<IFiltersKeyValuePairs>;
  sorting: string;
  pending: boolean;
  rejected: boolean;
  expired: boolean;
  promoted: boolean;
}
const MyLabFilterBottomSheet = ({
  openBottomSheet,
  setOpenBottomSheet,
  guid,
  title,
}: {
  openBottomSheet: boolean;
  setOpenBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
  guid?: string;
  title?: string;
}) => {
  const dispatch = useDispatch();

  const state = useSelector((state: RootState) => state.myStore);

  const [openAccordion, setOpenAccordion] = useState<boolean>(false);

  const [filters, setFilters] = useState<IMyStoreFilters>({
    categories: state.input_guid || [],
    sorting: state.sorting || '',
    pending: state.status_list.pending,
    rejected: state.status_list.rejected,
    expired: state.status_list.expired,
    promoted: state.status_list.promoted,
  });

  const sortingHandler = (sortingItem: IFiltersData) => {
    setFilters(prev => {
      return {...prev, sorting: sortingItem.value};
    });
  };

  const checkBoxHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilters(prev => {
      return {...prev, [event.target.name]: event.target.checked};
    });
  };

  useEffect(() => {
    setFilters({
      categories: state.input_guid || [],
      sorting: state.sorting || '',
      pending: state.status_list.pending,
      rejected: state.status_list.rejected,
      expired: state.status_list.expired,
      promoted: state.status_list.promoted,
    });
  }, [state]);

  return (
    <>
      <BottomSheet
        onDismiss={() => {
          setOpenBottomSheet(false);
          setFilters({
            categories: state.input_guid || [],
            sorting: state.sorting || '',
            pending: state.status_list.pending,
            rejected: state.status_list?.rejected,
            expired: state.status_list.rejected,
            promoted: state.status_list.promoted,
          });
        }}
        open={openBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
        className="transition ease-in-out delay-250 "
      >
        <div className="pt-2 pb-3 ">
          <div className="flex justify-between border-b px-3">
            <p className="font-Medium">فیلتر</p>
            <i
              className="icon-nameClose-remove text-xl"
              onClick={() => setOpenBottomSheet(false)}
            />
          </div>

          <div>
            <p className="text-sm px-3 mt-4 ">نوع آگهی</p>
            <InputLists filters={filters} setFilters={setFilters} code={18} />
          </div>

          <div className="flex items-center px-3 border-b">
            <Accordion
              accordionTitle="مرتب‌سازی بر اساس"
              setOpenAccordion={setOpenAccordion}
              openAccordion={openAccordion}
            >
              <div className="flex gap-2 pb-3 overflow-x-auto">
                {myStoreFiltersData.map(item => {
                  return (
                    <div
                      key={item.id}
                      className={cn(
                        'border-[1px] text-sm text-farm-shop-500 rounded-full border-farm-shop-500 w-fit py-2 px-2 whitespace-nowrap',
                        {
                          'bg-farm-shop-100': item.value === filters.sorting,
                        },
                      )}
                      onClick={() => sortingHandler(item)}
                    >
                      {item.title}
                    </div>
                  );
                })}
              </div>
            </Accordion>
          </div>
          <div className="flex flex-col gap-3 px-3 my-4">
            {myStoreMultiSelectData.map(item => {
              return (
                <CustomMultiCheckbox
                  title={item.title}
                  id={item.id}
                  value={item.value}
                  name={item.value}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    checkBoxHandler(e)
                  }
                  defaultChecked={
                    state[item.value as keyof typeof state] ? true : false
                  }
                  checked={
                    filters[item.value as keyof typeof filters] as boolean
                  }
                />
              );
            })}
          </div>

          <div className="flex flex-1 gap-2 px-3">
            <button
              className="flex justify-center items-center w-3/5 rounded text-white py-2.5 bg-farm-shop-500"
              onClick={() => {
                dispatch(
                  addFilters({
                    input_guid: filters.categories,
                    sorting: filters.sorting,
                    status_list: {
                      pending: filters.pending,
                      rejected: filters.rejected,
                      expired: filters.expired,
                      promoted: filters.promoted,
                    },
                  }),
                );
                setOpenBottomSheet(false);
              }}
            >
              اعمال فیلترها
            </button>
            <button
              className="flex justify-center items-center w-2/5 rounded py-2.5 border-[1px] text-red-500 !border-red-500"
              onClick={() => {
                dispatch(clearFilter());
                setFilters({
                  categories: [],
                  sorting: '',
                  pending: false,
                  rejected: false,
                  expired: false,
                  promoted: false,
                });
              }}
            >
              حذف فیلترها
            </button>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default MyLabFilterBottomSheet;
